import React, { FC, memo } from 'react';
import { useField } from 'formik';

import usePrefix from 'utils/usePrefix';
import FormDescription from 'components/ResqlExpert/FormDescription';
import {
  FormSectionStyled,
  TabBodyContentStyled,
} from 'components/ResqlExpert/SubmissionForm/styles';

import ExpertNote from '../ExpertNote';

const Results: FC = () => {
  const t = usePrefix('ResqlExpert');
  const [positiveField] = useField<string>('positive_outcomes');
  const [negativeField] = useField<string>('negative_outcomes');
  const [commentPositiveField, , commentPositiveHelpers] = useField<string>('comment_positive_outcomes');
  const [commentNegativeField, , commentNegativeHelpers] = useField<string>('comment_negative_outcomes');

  return (
    <TabBodyContentStyled>
      <FormSectionStyled>
        <FormDescription title={t('tab_results')}>
          <p>{t('tab_results_hint')}</p>
        </FormDescription>
        <p>
          <strong>{t('tab_results_positive')}</strong>
        </p>
        {positiveField.value ? <p>{positiveField.value}</p> : null}
        <ExpertNote
          id="expert-note-results-positive"
          label={t('tab_results_positive')}
          value={commentPositiveField.value ?? ''}
          onChange={(v) => commentPositiveHelpers.setValue(v)}
        />
        <p>
          <strong>{t('tab_results_negative')}</strong>
        </p>
        {negativeField.value ? <p>{negativeField.value}</p> : null}
        <ExpertNote
          id="expert-note-results-negative"
          label={t('tab_results_negative')}
          value={commentNegativeField.value ?? ''}
          onChange={(v) => commentNegativeHelpers.setValue(v)}
        />
      </FormSectionStyled>
    </TabBodyContentStyled>
  );
};

export default memo(Results);
